<template>
  <div>
    <div class="d-flex justify-content-between align-items-baseline w-100">
      <h5 class="font-weight-bold text-secondary">
        <u>
          <router-link :to="{
              path: '/shipment/' + item.id
            }"
          >Invoice#{{ item.shipmentId }}</router-link>
        </u>
      </h5>
      <h6 class="text-secondary">
        <b-dropdown
          id="dropdown-1"
          toggle-class="rounded-pill text-xs py-0 px-2 mr-1"
          menu-class="text-xs border-0 shadow-lg"
          variant="secondary"
        >
          <template v-slot:button-content>
            <b-icon-flag-fill
              :style="{ color: item.flag ? flagColor[item.flag] : '#eeeeee' }"
            ></b-icon-flag-fill>
          </template>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'delayed' ? '' : 'delayed'))"
          >
            <div>
              <b-icon-flag-fill
                style="color: #d476fd"
              ></b-icon-flag-fill>
              Delayed
            </div>
            <b-icon-check v-if="item.flag === 'delayed'"></b-icon-check>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'pickup' ? '' : 'pickup'))"
          >
            <div>
              <b-icon-flag-fill
                style="color: #f1c32b"
              ></b-icon-flag-fill>
              Pick Up Error
            </div>
            <b-icon-check v-if="item.flag === 'pickup'"></b-icon-check>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'other' ? '' : 'other'))"
          >
            <div>
              <b-icon-flag-fill
                style="color: #8abdd0"
              ></b-icon-flag-fill>
              Other Error
            </div>
            <b-icon-check v-if="item.flag === 'other'"></b-icon-check>
          </b-dropdown-item>
        </b-dropdown>
        <b-badge pill style="background: #d29f57; color: white;">
          Delivering
        </b-badge>
      </h6>
    </div>
    <h6 class="text-secondary text-left">
      {{ item.shipperName }}
      <b-icon-dot></b-icon-dot>
      {{ item.shipperCity }}
      <b-icon-arrow-right></b-icon-arrow-right>
      {{ item.consigneeCity }}
      <b-icon-dot></b-icon-dot>
      Date Created {{ new Date(item.dateCreated).toLocaleDateString('en-US', {timeZone: 'UTC'})}}
    </h6>
    <div class="text-left mb-0 pb-3 font-weight-bold" style="font-size: 14px; color: gray;">
      Outstanding Balance ${{ item.outStandingBalance }}
    </div>
    <b-collapse
      :id="'result-card' + item.id"
      class="text-left text-xs text-gray-900"
    >
      <h6 class="text-muted mt-4 font-weight-bold" style="font-size: smaller;">
        ADDITIONAL DETAILS
      </h6>
      <div class="mb-3 mx-3">
        <b-row class="border rounded pt-2 mb-3">
          <b-col md="4" class="pb-2">
            <label class="text-gray-400 font-weight-bold mb-0">Sender</label>
            <div class="text-sm">{{ item.shipperName }}</div>
          </b-col>
          <b-col md="4" class="pb-2">
            <label class="text-gray-400 font-weight-bold mb-0">Phone</label>
            <div class="text-sm">{{ item.shipperPhone }}</div>
          </b-col>
          <b-col md="4" class="pb-2">
            <label class="text-gray-400 font-weight-bold mb-0">Address</label>
            <div class="text-sm">{{ item.consigneeAddress }}</div>
          </b-col>
        </b-row>
        <b-row class="border rounded pt-2 mb-3">
          <b-col md="4" class="pb-2">
            <label class="text-gray-400 font-weight-bold mb-0">Date</label>
            <div class="text-sm">{{ new Date(item.pickupDate).toLocaleDateString(
              'en-US', {timeZone: 'UTC'})}}
              </div>
          </b-col>
          <b-col md="4" class="pb-2">
            <label class="text-gray-400 font-weight-bold mb-0">Time</label>
            <div class="text-sm">@ {{ new Date(item.pickupDate).toLocaleTimeString(
              'en-US', {timeZone: 'UTC'})}}
              </div>
          </b-col>
        </b-row>
        <b-row class="border rounded pt-2">
          <b-row class="w-100 m-0">
            <b-col md="4" lg="3" xl="2" class="pb-2">
              <label class="text-gray-400 font-weight-bold mb-0">Pieces</label>
              <div>
                <span class="text-xl text-gray-800">{{ completedCount }}</span>
                <span class="text-xs text-gray-500">/{{ item.items.length }}</span>
              </div>
            </b-col>
            <b-col md="8" lg="9" xl="10" class="pb-2 d-none d-md-block">
              <label class="text-gray-400 font-weight-bold mb-2">Progress</label>
              <b-progress
                v-if="completedPercentage < 100"
                :max="100"
                class="w-100"
                style="border-radius: 30px;"
              >
                <b-progress-bar :value="completedPercentage" variant="warning" striped>
                  <span>{{ completedPercentage }}%</span>
                </b-progress-bar>
              </b-progress>
              <b-button
                v-else
                block
                class="text-xs py-0"
                variant="success"
                style="border-radius: 30px;"
                @click="()=>{}"
              >Complete</b-button>
            </b-col>
          </b-row>

          <b-row v-for="(piece, idx) in item.items" :key="idx" class="w-100 mx-0">
            <hr class="w-100 my-0" />
            <b-col offset-md="4" offset-lg="3" offset-xl="2" class="my-2">
              <b-form-checkbox
                :id="`checkbox${piece.id}`"
                class="d-flex align-items-center"
                v-model="piece.completed"
                :name="`checkbox${idx}`"
              >
                {{ piece.description }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-row>
      </div>
      <b-button
          class="text-xs py-0 px-2 mr-1"
          variant="success"
          style="border-radius: 30px; "
          @click="updateItems()"
        >
          update
      </b-button>
        <!-- <b-row class="border rounded pt-2"> -->
          <!-- <b-button
            block
            class="text-xs py-0"
            variant="success"
            style="border-radius: 30px;"
            @click="()=>{}"
          >Delievered</b-button> -->
        <!-- </b-row> -->
      <!-- </div> -->
    </b-collapse>
  </div>
</template>

<script>
import { updateDeliveringItem } from '../api/shipment';

export default {
  name: 'SearchResultPickup',
  props: ['item', 'name', 'phoneNumber', 'destination', 'bol', 'accountNumber'],
  data() {
    return {
      flagColor: {
        delayed: '#d476fd',
        pickup: '#f1c32b',
        other: '#8abdd0',
      },
    };
  },
  methods: {
    updateItems() {
      const complete = this.completedPercentage === 100;
      const data = {
        data:
          {
            items: this.item.items, completed: complete, shipmentId: this.item.id,
          },
      };
      updateDeliveringItem(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.$emit('update-item');
        }).catch((err) => {
          this.$emit('error-item', err.response.data.error);
        });
    },
  },
  computed: {
    completedCount() {
      return this.item.items.reduce((acc, curr) => (curr.completed ? acc + 1 : acc), 0);
    },
    completedPercentage() {
      return +((this.completedCount / this.item.items.length) * 100).toFixed(2);
    },
  },
  mounted() {
    if (!('flag' in this.item)) {
      this.$set(this.item, 'flag', '');
    }
  },
};
</script>

<style scoped>

</style>
